import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import type { ConditionPanelHost } from '@/types/advanceFilter';

/**
 * Open/anchor/close plumbing shared by every condition popover. A condition is
 * either hosted — the filter strip owns the popover and anchors it to a chip,
 * so there is no trigger button and the popover is open from mount — or
 * self-managed, where it renders its own trigger and opens on click.
 *
 * `triggerRef` is a callback ref on purpose: storing the element in state is
 * what re-renders the popover once its anchor exists.
 */
export const useConditionPanel = (host, onPanelClose) => {
  const $ = _c(9);
  const [triggerEl, setTriggerEl] = useState(null);
  const [isOpen, setIsOpen] = useState(!!host);
  const t0 = !!host;
  const t1 = host?.anchorEl ?? triggerEl;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(true);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== host || $[2] !== onPanelClose) {
    t3 = () => {
      setIsOpen(false);
      onPanelClose?.();
      host?.onClose();
    };
    $[1] = host;
    $[2] = onPanelClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isOpen || $[5] !== t0 || $[6] !== t1 || $[7] !== t3) {
    t4 = {
      isHosted: t0,
      isOpen,
      triggerRef: setTriggerEl,
      anchorEl: t1,
      open: t2,
      close: t3
    };
    $[4] = isOpen;
    $[5] = t0;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};